import { render, staticRenderFns } from "./ViewContentNumero.vue?vue&type=template&id=4830edab&"
import script from "./ViewContentNumero.vue?vue&type=script&lang=js&"
export * from "./ViewContentNumero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports